import styled from "styled-components";

export const ContainerDiv = styled.div`
  max-width: 2000px;
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  color: #1e2228;
  box-sizing: border-box;
  
  @media (max-width: 940px) {
    padding: 93px 30px;
  }
`;
export const HeaderDiv = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  left: 0px;
  z-index: 2000;
`;
export const BackDiv = styled.div`
  & a {
    color: #1b49ea;
    font-size: 16px;
    display: flex;
    align-items: center;
    &:before {
      content: "";
      height: 10px;
      width: 10px;
      border-left: 2px solid #1b49ea;
      border-bottom: 2px solid #1b49ea;
      position: relative;
      transform: rotate(45deg);
      margin-right: 12px;
    }
  }
`;
export const MainHeadingDiv = styled.div`
  font-size: 24px;
  font-weight: bold;
  margin-top: 24px;
`;
export const SubHeadingDiv = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-top: 36px;
`;
export const Text1Div = styled.div`
  font-size: 14px;
`;
export const HeadingDiv = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin: 35px 0px 15px 0px;
  & span {
    color: #ff2c91;
  }
`;
export const Heading3Div = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin: 35px 0px 15px 0px;
  display: flex;
  align-items: center;
`;
export const Heading2Div = styled.div`
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 6px;
`;
export const Text2Div = styled.div`
  font-size: 14px;
  color: #939599;
  margin-top: 12px;
`;
export const Text3Div = styled.div`
  font-size: 12px;
`;
export const ShowLessButton = styled.button`
  font-size: 16px;
  font-weight: bold;
  color: #1b49ea;
  background: none;
  border: none;
  padding: 0px;
  margin: 30px 0px 0px 0px;
  align-self: flex-start;
`;
export const RowDiv = styled.div`
  display: flex;
`;
export const ColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
export const RoleWrapDiv = styled.div`
  display: flex;
  & label {
    margin-right: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    & input {
      margin-right: 10px;
    }
  }
  & label:last-child {
    margin-right: 0px;
  }
`;
export const LocationWrapDiv = styled.div`
  display: flex;
  & label {
    margin-right: 40px;display:flex;justify-content:flex-start;align-items:center;
    & input {
      margin-right: 10px;
    }
  }
  & label:last-child {
    margin-right: 0px;
  }
`;
export const SearchButton = styled.button`
  background: #1b49ea;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  border: none;
  margin: 50px 0px 0px 0px;
  padding: 19px 28px;
  align-self: flex-start;
`;
export const SliderDiv = styled.div`
  margin-top: 30px;
  position: relative;
  z-index: 1;

  margin: 30px 0px 8px 0px;

  .ant-slider {
    margin: 20px 8px 20px 8px;
  }

  .ant-slider-dot {
    display: none;
  }
  .ant-tooltip {
    z-index: 999 !important;
  }

  .ant-slider-mark {
    span {
      min-width: 0px;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      color: #979797;
      transform: none !important;
      white-space: nowrap;
    }
    span:last-child {
      right: 0% !important;
      left: auto !important;
    }
  }

  .ant-slider-rail {
    height: 6px !important;
    background: #b8b8b8;
    border-radius: 90px;
  }

  .ant-slider-track {
    background: #ff2c91;
    border-radius: 90px;
    height: 6px !important;
  }

  .ant-slider-handle {
    border: none !important;
    background: #ff2c91;
  }
  .ant-tooltip-inner {
    min-height: 38px !important;
    min-width: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
  }
  // .ant-tooltip-arrow {
  //   height: 0px !important;
  //   width: 0px !important;
  //   top: 0px !important;
  //   border-top: 26px solid #ff2c91;
  //   border-right: 18px solid transparent;
  //   border-left: 18px solid transparent;
  //   border-bottom: 0px solid transparent;
  //   z-index: -1;

  //   & span {
  //     display: none;
  //   }
  // }
  .ant-slider-handle {
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
  }

  &:hover {
    .ant-slider-track {
      background: #ff2c91;
      border-radius: 90px;
      height: 6px !important;
    }
  }
`;
export const HiddenDiv = styled.div`
  display: ${(props) => (props.show === true ? "flex" : "none")};
  flex-direction: column;
`;
export const AutosearchDiv = styled.div`
  width: 100%;
  .ant-select {
    width: 100%;
    margin-bottom: 16px;
  }
  .ant-select-selector {
    height: 54px !important;
    padding: 12px 16px !important;
    border-radius: 6px !important;
    border: 1px solid #c9c9c9 !important;
    box-shadow: none !important;
    .ant-select-selection-search {
      padding: 11px 0px !important;
      right: 16px;
      left: 16px;
    }
    .ant-select-selection-placeholder {
      color: #7e7e7e !important;
    }
  }
`;
export const ErrorDiv = styled.div`
  color: red;
  font-size: 14px;
  margin-top: 16px;
`;
export const MandatoryDiv = styled.div`
  color: #ff2c91;
  font-size: 12px;
  font-weight: normal;
  margin-top: 50px;
`;
export const SkillOptionDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  & button {
    font-size: 14px;
    color: #1b49ea;
    border: none;
    background: none;
    margin: 0px;
    padding: 0px;
  }
`;
export const AddSkillButton = styled.button`
  height: 54px;
  width: 54px;
  border: none;
  background-color: #ffffff;
  flex-shrink: 0;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  & img {
    width: 30px;
    height: 30px;
    display: block;
  }
`;
export const RemoveSkillButton = styled.button`
  height: 54px;
  width: 54px;
  border: none;
  background-color: #ffffff;
  flex-shrink: 0;
  border-radius: 6px;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  & img {
    width: 30px;
    height: 30px;
    display: block;
  }
`;
export const ResetFilterButton = styled.button`
  color: #ff2c91;
  font-size: 12px;
  margin: 0px 0px 0px 12px;
  padding: 3px 8px;
  border: none;
  border-radius: 4px;
`;
export const NotAvailableDiv = styled.div`
  display: flex;
  padding: 17px;
  background-color: #ffebd2;
  border-radius: 8px;
  align-items: flex-start;
  & img {
    width: 20px;
    flex-shrink: 0;
    margin-top: 4px;
  }
  & > div {
    display: flex;
    flex-direction: column;
    font-size: 12px;
    color: #1e2228;
    margin-left: 13px;
    & div:first-child {
      font-weight: bold;
    }
  }
`;
